function Unavailable() {
    return (
        <div className="body-central-default">
            <div className="gray-league-paragraph">Looks like the link you're looking for is a dead end. Or at least it's something that doesn't have a home yet!</div>
            <br></br>
            <a className="gray-league-paragraph"href="/">Main Page</a>
        </div>
    )
}

export default Unavailable;